import React from 'react';
import clsx from 'clsx';

const CartSubbrand = ({ subBrand, handleRemove }) => {
  return (
    <div
      className={clsx('flex items-center justify-end', {
        'justify-between': subBrand,
      })}
    >
      {subBrand && (
        <div className="body-3 flex items-center gap-0.5 [&_img]:size-5">
          <span>{subBrand}</span>
          <domaine-inline-icons data-icon={subBrand} />
        </div>
      )}

      <button
        onClick={() => handleRemove()}
        className="body-3-underline text-grey-dark hover:no-underline"
      >
        {window.TMW.Strings.cart.remove}
      </button>
    </div>
  );
};

export default CartSubbrand;
